import React, { Component } from 'react';

class HLBCampaignMainBanner extends Component {
  render() {
    return (
      <div className="hlb-campaign-main-banner">
        <h2 className="hlb-campaign-main-banner-title">MHub Loan Tracker Campaign</h2>
        <span className="hlb-campaign-main-banner-subtitle">28 Aug - 31 Dec 2025</span>
        <div className="hlb-campaign-main-banner-content">
          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', gap: '0.5em' }}>
            <span style={{ fontFamily: 'Montserrat', fontSize: '11px', lineHeight: '100%', fontWeight: '600' }}>Get</span>
            <span style={{ fontFamily: 'Cinzel', fontSize: '26px', lineHeight: '100%', fontWeight: '700' }}>RM</span>
          </div>
          <span style={{ fontFamily: 'Cinzel', fontSize: '52px', lineHeight: '100%', marginTop: '5px', fontWeight: '900' }}>10</span>
          <span style={{ fontSize: '12px', fontWeight: '600' }}>Get RM10 from MHub for every case you send to Hong Leong Bank!*</span>
        </div>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'end', marginTop: '1em', marginRight: '1em' }}>
          <span style={{ fontSize: '8px', fontWeight: '600', letterSpacing: '4%' }}>*Terms & conditions apply</span>
        </div>
      </div>
    );
  }
}

export default HLBCampaignMainBanner;



// WEBPACK FOOTER //
// ./src/components/HLBCampaign/HLBCampaignMainBanner.jsx